//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            focus: false,
            keyword: '',
        }
    },
    watch: {
        autoFocus: {
            handler (latest, old) {
                if (latest !== old) {
                    this.focus = latest
                }
            },
            immediate: true
        },
        value(latest) {
            this.keyword = latest
        },
        keyword(latest){
            this.$emit("input", latest)
        }
    },
    methods: {
        onConfirm(e) {
            this.$emit('confirm', e.target.value)
        },
        onFocus() {
            this.$emit('focus')
            this.focus = true
        },
        onBlur() {
            this.$emit('blur')
            this.focus = false
        }
    },
    props: {
        "value": String,
        "placeholder": String,
        "disabled": Boolean,
        "auto-focus": Boolean,
        "confirm-type": {
            type: String,
            default: ''
        },
        "placeholder-class": String,
        "placeholder-style": String
    }
}
